/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_3_PInputs */

const en_terms_3_p = /** @type {(inputs: Terms_3_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do not use Bystep to build or plan anything illegal, to infringe others' rights, to attack or overload the service, to scrape or resell it, or to circumvent quotas. We may suspend accounts that break these rules.`)
};

const id_terms_3_p = /** @type {(inputs: Terms_3_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jangan memakai Bystep untuk membangun atau merencanakan sesuatu yang melanggar hukum, melanggar hak orang lain, menyerang atau membebani layanan, mengambil data secara massal atau menjualnya kembali, atau mengakali kuota. Kami dapat menangguhkan akun yang melanggar aturan ini.`)
};

/**
* | output |
* | --- |
* | "Do not use Bystep to build or plan anything illegal, to infringe others' rights, to attack or overload the service, to scrape or resell it, or to circumvent ..." |
*
* @param {Terms_3_PInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const terms_3_p = /** @type {((inputs?: Terms_3_PInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_3_PInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_terms_3_p(inputs)
	return en_terms_3_p(inputs)
});